// extracted by mini-css-extract-plugin
export default {"base":"base__hint__k0a5G","size-tiny":"size-tiny__hint__GlIU7","size-small":"size-small__hint__cfbHx"};